/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2UserSingleCircle/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2UserSingleCircle({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2UserSingleCircle",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 15,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1",
  fill3 = "#F5F7FA"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2UserSingleCircle.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 15"
 style={{'--as-1-ZUThFO': alignSelf,'--mt-2-ZUThFO': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZUThFO': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZUThFO': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZUThFO': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZUThFO': opacity,'--w-10-ZUThFO': typeof width === 'number' ? `${width}px` : width,'--h-11-ZUThFO': typeof height === 'number' ? `${height}px` : height,'--f-12-ZUThFO': fill,'--a-7-ZUThFO': isAnimated ? animation : "none",'--sd-8-ZUThFO': isAnimated ? strokeDashoffset : 0,'--sd-9-ZUThFO': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2UserSingleCircle.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M14 7.5a6.977 6.977 0 01-1.941 4.838A6.98 6.98 0 017.02 14.5H6.98a6.98 6.98 0 01-5.039-2.162A7 7 0 1114 7.5zM11.243 11A5.489 5.489 0 007 9a5.489 5.489 0 00-4.243 2A5.489 5.489 0 007 13a5.489 5.489 0 004.243-2zM7 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
 style={{'--f-12-ZUThFO': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Tysiav2UserSingleCircle.SvgPath:1"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M11.243 11A5.489 5.489 0 007 9a5.489 5.489 0 00-4.242 2A5.489 5.489 0 007 13a5.489 5.489 0 004.243-2zM7.001 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
 style={{'--f-12-ZUThFO': fill3}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}